import React, { useEffect, useRef, useState } from "react"
import { Alert, Button, Col, Form, Modal, Row } from "react-bootstrap"
import { NumericFormat } from "react-number-format"
import {
  AddReciboEventoModalProps,
  FormaDePago,
  FormaDePagoLabels,
  IDetallePago,
  IReciboEventoRequest,
} from "../../../../../interfaces/IRecibo"
import { TipoEvento } from "../../../../../interfaces/TipoEvento"
import SpinnerOverlay from "../../../../SpinnerOverlay/SpinnerOverlay"
import "../../RecibosModal/AddRecibosModal/AddRecibosModal.css"

const AddReciboEventoModal: React.FC<AddReciboEventoModalProps> = ({
  show,
  handleClose,
  onReciboCreado,
  eventoId,
  usuarioCarga,
  tipoEvento,
}) => {
  const mostrarBaile = tipoEvento === TipoEvento.CUMPLEANIOS_BODAS
  const [tarjetasAdulto, setTarjetasAdulto] = useState(0)
  const [tarjetasMenor, setTarjetasMenor] = useState(0)
  const [tarjetasBaile, setTarjetasBaile] = useState(0)
  const [mesaDulce, setMesaDulce] = useState(0)
  const [posCena, setPosCena] = useState(0)
  const [barra, setBarra] = useState(0)
  const [esPagoSenia, setEsPagoSenia] = useState(false)
  const [montoTransferencia, setMontoTransferencia] = useState(0)
  const [montoEfectivo, setMontoEfectivo] = useState(0)
  const [montoCredito, setMontoCredito] = useState(0)
  const [montoDebito, setMontoDebito] = useState(0)
  const [transferenciaNombre, setTransferenciaNombre] = useState("")
  const [transferenciaApellido, setTransferenciaApellido] = useState("")
  const [transferenciaDni, setTransferenciaDni] = useState("")
  const [transferenciaTelefono, setTransferenciaTelefono] = useState("")
  const [transferenciaEntidadBancaria, setTransferenciaEntidadBancaria] =
    useState("")
  const [eventoIdActual, setEventoIdActual] = useState(0)
  const [loading, setLoading] = useState(false)
  const [errorValidacion, setErrorValidacion] = useState<string>("")
  const [advertenciaTransferencia, setAdvertenciaTransferencia] =
    useState<string>("")
  const modalBodyRef = useRef<HTMLDivElement | null>(null)
  const totalRecibo =
    montoTransferencia + montoEfectivo + montoCredito + montoDebito
  const requiereDatosTransferencia =
    usuarioCarga === "Usuario A" && montoTransferencia > 0

  useEffect(() => {
    if (eventoId) setEventoIdActual(eventoId)
  }, [eventoId])

  useEffect(() => {
    if (!errorValidacion && !advertenciaTransferencia) return
    requestAnimationFrame(() => {
      modalBodyRef.current?.scrollTo({ top: 0, behavior: "smooth" })
    })
  }, [errorValidacion, advertenciaTransferencia])

  const resetForm = () => {
    setTarjetasAdulto(0)
    setTarjetasMenor(0)
    setTarjetasBaile(0)
    setMesaDulce(0)
    setPosCena(0)
    setBarra(0)
    setEsPagoSenia(false)
    setMontoTransferencia(0)
    setMontoEfectivo(0)
    setMontoCredito(0)
    setMontoDebito(0)
    setTransferenciaNombre("")
    setTransferenciaApellido("")
    setTransferenciaDni("")
    setTransferenciaTelefono("")
    setTransferenciaEntidadBancaria("")
    setLoading(false)
    setErrorValidacion("")
    setAdvertenciaTransferencia("")
  }

  const validarYObtenerDetallesPago = (): IDetallePago[] | null => {
    const detalles: IDetallePago[] = []
    if (montoTransferencia > 0)
      detalles.push({ formaDePago: FormaDePago.TRANSFERENCIA, monto: montoTransferencia })
    if (montoEfectivo > 0)
      detalles.push({ formaDePago: FormaDePago.EFECTIVO, monto: montoEfectivo })
    if (montoCredito > 0)
      detalles.push({ formaDePago: FormaDePago.CREDITO, monto: montoCredito })
    if (montoDebito > 0)
      detalles.push({ formaDePago: FormaDePago.DEBITO, monto: montoDebito })

    if (detalles.length === 0) {
      setErrorValidacion("Debe ingresar al menos un monto mayor a 0")
      return null
    }
    setErrorValidacion("")
    return detalles
  }

  const handleCancelar = () => {
    resetForm()
    handleClose()
  }

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    if (!esPagoSenia) {
      const totalTarjetas =
        tarjetasAdulto +
        tarjetasMenor +
        (mostrarBaile ? tarjetasBaile + mesaDulce + posCena + barra : 0)
      if (totalTarjetas === 0) {
        setErrorValidacion(
          mostrarBaile
            ? "Debe ingresar al menos una tarjeta o adicional"
            : "Debe ingresar al menos una tarjeta (adulto o menor)",
        )
        return
      }
    }

    if (totalRecibo <= 0) {
      setErrorValidacion("El total del recibo debe ser mayor a 0")
      return
    }

    const detallesPago = validarYObtenerDetallesPago()
    if (!detallesPago) return

    if (
      requiereDatosTransferencia &&
      !advertenciaTransferencia &&
      (!transferenciaNombre.trim() ||
        !transferenciaApellido.trim() ||
        !transferenciaDni.trim() ||
        !transferenciaTelefono.trim() ||
        !transferenciaEntidadBancaria.trim())
    ) {
      setAdvertenciaTransferencia(
        "Hay datos de transferencia vacíos. ¿Desea guardar el recibo de todas formas?",
      )
      return
    }

    setLoading(true)

    const newRecibo: IReciboEventoRequest = {
      tarjetasAdulto: esPagoSenia ? 0 : tarjetasAdulto,
      tarjetasMenor: esPagoSenia ? 0 : tarjetasMenor,
      tarjetasBaile: esPagoSenia || !mostrarBaile ? 0 : tarjetasBaile,
      mesaDulce: esPagoSenia || !mostrarBaile ? 0 : mesaDulce,
      posCena: esPagoSenia || !mostrarBaile ? 0 : posCena,
      barra: esPagoSenia || !mostrarBaile ? 0 : barra,
      seniaDePago: esPagoSenia ? true : undefined,
      detallesPago: detallesPago.map((d) => ({
        formaDePago: d.formaDePago,
        monto: parseFloat(d.monto.toFixed(2)),
      })),
      totalRecibo: parseFloat(totalRecibo.toFixed(2)),
      eventoId: eventoIdActual,
      usuarioCarga,
      ...(requiereDatosTransferencia && {
        transferenciaNombre: transferenciaNombre.trim(),
        transferenciaApellido: transferenciaApellido.trim(),
        transferenciaDni: transferenciaDni.trim(),
        transferenciaTelefono: transferenciaTelefono.trim(),
        transferenciaEntidadBancaria: transferenciaEntidadBancaria.trim(),
      }),
    }

    try {
      onReciboCreado(newRecibo)
    } catch (error) {
      console.error("Error al guardar el recibo", error)
    } finally {
      resetForm()
      handleClose()
    }
  }

  return (
    <Modal
      show={show}
      onHide={handleClose}
      dialogClassName="modal-add"
      backdropClassName="custom-backdrop"
      scrollable
      fullscreen="sm-down"
    >
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>Cargar recibo del evento</Modal.Title>
        </Modal.Header>
        <Modal.Body ref={modalBodyRef}>
          {loading && <SpinnerOverlay />}

          {errorValidacion && (
            <Alert variant="danger" onClose={() => setErrorValidacion("")} dismissible>
              {errorValidacion}
            </Alert>
          )}

          {advertenciaTransferencia && (
            <Alert
              variant="warning"
              onClose={() => setAdvertenciaTransferencia("")}
              dismissible
            >
              <div className="d-flex align-items-center justify-content-between gap-2 flex-wrap">
                <span>{advertenciaTransferencia}</span>
                <Button variant="warning" type="submit" size="sm">
                  Sí, guardar
                </Button>
              </div>
            </Alert>
          )}

          <Row className="mt-1">
            <Col md={mostrarBaile ? 4 : 6}>
              <Form.Group controlId="tarjetasAdulto">
                <Form.Label className={esPagoSenia ? "text-muted" : ""}>
                  Tarjetas Adulto
                </Form.Label>
                <Form.Control
                  type="number"
                  value={esPagoSenia ? "" : tarjetasAdulto}
                  onChange={(e) => setTarjetasAdulto(Number(e.target.value))}
                  disabled={esPagoSenia}
                />
              </Form.Group>
            </Col>
            <Col md={mostrarBaile ? 4 : 6}>
              <Form.Group controlId="tarjetasMenor">
                <Form.Label className={esPagoSenia ? "text-muted" : ""}>
                  Tarjetas Menor
                </Form.Label>
                <Form.Control
                  type="number"
                  value={esPagoSenia ? "" : tarjetasMenor}
                  onChange={(e) => setTarjetasMenor(Number(e.target.value))}
                  disabled={esPagoSenia}
                />
              </Form.Group>
            </Col>
            {mostrarBaile && (
              <Col md={4}>
                <Form.Group controlId="tarjetasBaile">
                  <Form.Label className={esPagoSenia ? "text-muted" : ""}>
                    Tarjetas Baile
                  </Form.Label>
                  <Form.Control
                    type="number"
                    value={esPagoSenia ? "" : tarjetasBaile}
                    onChange={(e) => setTarjetasBaile(Number(e.target.value))}
                    disabled={esPagoSenia}
                  />
                </Form.Group>
              </Col>
            )}
          </Row>

          <Row className="mt-3">
            <Col md={12}>
              <Form.Group controlId="esPagoSenia">
                <Form.Check
                  type="checkbox"
                  label="Pago de Seña"
                  checked={esPagoSenia}
                  onChange={(e) => {
                    setEsPagoSenia(e.target.checked)
                    if (e.target.checked) {
                      setTarjetasAdulto(0)
                      setTarjetasMenor(0)
                      setTarjetasBaile(0)
                      setMesaDulce(0)
                      setPosCena(0)
                      setBarra(0)
                    }
                  }}
                />
              </Form.Group>
            </Col>
          </Row>

          {mostrarBaile && (
            <Row className="mt-2">
              <Col md={4}>
                <Form.Group controlId="mesaDulce">
                  <Form.Label className={esPagoSenia ? "text-muted" : ""}>
                    Mesa dulce
                  </Form.Label>
                  <Form.Control
                    type="number"
                    value={esPagoSenia ? "" : mesaDulce}
                    onChange={(e) => setMesaDulce(Number(e.target.value))}
                    disabled={esPagoSenia}
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group controlId="posCena">
                  <Form.Label className={esPagoSenia ? "text-muted" : ""}>
                    Pos cena
                  </Form.Label>
                  <Form.Control
                    type="number"
                    value={esPagoSenia ? "" : posCena}
                    onChange={(e) => setPosCena(Number(e.target.value))}
                    disabled={esPagoSenia}
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group controlId="barra">
                  <Form.Label className={esPagoSenia ? "text-muted" : ""}>
                    Barra
                  </Form.Label>
                  <Form.Control
                    type="number"
                    value={esPagoSenia ? "" : barra}
                    onChange={(e) => setBarra(Number(e.target.value))}
                    disabled={esPagoSenia}
                  />
                </Form.Group>
              </Col>
            </Row>
          )}

          <hr className="my-3" />

          <Row className="mt-3">
            <Col md={6}>
              <Form.Group controlId="montoTransferencia">
                <Form.Label>{FormaDePagoLabels[FormaDePago.TRANSFERENCIA]}</Form.Label>
                <NumericFormat
                  className="form-control"
                  value={montoTransferencia === 0 ? "" : montoTransferencia}
                  onValueChange={({ floatValue }) => setMontoTransferencia(floatValue || 0)}
                  thousandSeparator="."
                  decimalSeparator=","
                  decimalScale={2}
                  allowNegative={false}
                  prefix="$ "
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group controlId="montoEfectivo">
                <Form.Label>{FormaDePagoLabels[FormaDePago.EFECTIVO]}</Form.Label>
                <NumericFormat
                  className="form-control"
                  value={montoEfectivo === 0 ? "" : montoEfectivo}
                  onValueChange={({ floatValue }) => setMontoEfectivo(floatValue || 0)}
                  thousandSeparator="."
                  decimalSeparator=","
                  decimalScale={2}
                  allowNegative={false}
                  prefix="$ "
                />
              </Form.Group>
            </Col>
          </Row>

          <Row className="mt-3">
            <Col md={6}>
              <Form.Group controlId="montoCredito">
                <Form.Label>{FormaDePagoLabels[FormaDePago.CREDITO]}</Form.Label>
                <NumericFormat
                  className="form-control"
                  value={montoCredito === 0 ? "" : montoCredito}
                  onValueChange={({ floatValue }) => setMontoCredito(floatValue || 0)}
                  thousandSeparator="."
                  decimalSeparator=","
                  decimalScale={2}
                  allowNegative={false}
                  prefix="$ "
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group controlId="montoDebito">
                <Form.Label>{FormaDePagoLabels[FormaDePago.DEBITO]}</Form.Label>
                <NumericFormat
                  className="form-control"
                  value={montoDebito === 0 ? "" : montoDebito}
                  onValueChange={({ floatValue }) => setMontoDebito(floatValue || 0)}
                  thousandSeparator="."
                  decimalSeparator=","
                  decimalScale={2}
                  allowNegative={false}
                  prefix="$ "
                />
              </Form.Group>
            </Col>
          </Row>

          {requiereDatosTransferencia && (
            <div className="transferencia-datos-box">
              <div className="d-flex align-items-center mt-2 mb-1">
                <div className="flex-grow-1 border-top"></div>
                <span className="mx-3 text-muted fw-semibold small">
                  Datos Transferencia
                </span>
                <div className="flex-grow-1 border-top"></div>
              </div>
              <Row className="mt-2">
                <Col md={6}>
                  <Form.Group controlId="transferenciaNombre">
                    <Form.Label>Nombre</Form.Label>
                    <Form.Control
                      value={transferenciaNombre}
                      onChange={(e) => setTransferenciaNombre(e.target.value)}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group controlId="transferenciaApellido">
                    <Form.Label>Apellido</Form.Label>
                    <Form.Control
                      value={transferenciaApellido}
                      onChange={(e) => setTransferenciaApellido(e.target.value)}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row className="mt-2">
                <Col md={4}>
                  <Form.Group controlId="transferenciaDni">
                    <Form.Label>DNI</Form.Label>
                    <Form.Control
                      value={transferenciaDni}
                      onChange={(e) => setTransferenciaDni(e.target.value)}
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group controlId="transferenciaTelefono">
                    <Form.Label>Teléfono</Form.Label>
                    <Form.Control
                      value={transferenciaTelefono}
                      onChange={(e) => setTransferenciaTelefono(e.target.value)}
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group controlId="transferenciaEntidadBancaria">
                    <Form.Label>Entidad bancaria</Form.Label>
                    <Form.Control
                      value={transferenciaEntidadBancaria}
                      onChange={(e) =>
                        setTransferenciaEntidadBancaria(e.target.value)
                      }
                    />
                  </Form.Group>
                </Col>
              </Row>
            </div>
          )}

          <div className="border-top mt-3 pt-2"></div>
          <Row className="mt-1 align-items-center">
            <Col xs="auto">
              <Form.Label className="mb-0 text-nowrap fw-semibold">
                Total del Recibo
              </Form.Label>
            </Col>
            <Col>
              <Form.Group controlId="totalRecibo" className="mb-0">
                <NumericFormat
                  className="form-control bg-light"
                  value={totalRecibo === 0 ? "" : totalRecibo}
                  thousandSeparator="."
                  decimalSeparator=","
                  decimalScale={2}
                  prefix="$ "
                  disabled
                  readOnly
                />
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCancelar}>
            Cancelar
          </Button>
          <Button variant="primary" type="submit" disabled={loading}>
            Guardar Recibo
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  )
}

export default AddReciboEventoModal
